import type { DisplayCardProps, DisplayCardRarity } from './DisplayCard'

type DisplayCardChromeSource = {
  exploreOrigin?: {
    rarity?: DisplayCardRarity | string | null
    featured?: boolean | null
  } | null
  provenance?: 'community-shared' | 'editors-pick' | 'official' | string | null
  publicWorkspaceId?: string | null
  isSeeded?: boolean | null
}

const DISPLAY_CARD_RARITIES = new Set<DisplayCardRarity>([
  'common',
  'rare',
  'epic',
  'legendary',
  'mythic',
])

export const displayCardRarityAccent = (rarity: DisplayCardRarity): string => `var(--rarity-${rarity})`

const normalizeRarity = (value: unknown): DisplayCardRarity | undefined => {
  if (typeof value !== 'string') return undefined
  const normalized = value.toLowerCase() as DisplayCardRarity
  return DISPLAY_CARD_RARITIES.has(normalized) ? normalized : undefined
}

export const toDisplayCardChrome = (source: DisplayCardChromeSource | null | undefined): Partial<DisplayCardProps> => {
  if (!source) return {}
  const rarity = normalizeRarity(source.exploreOrigin?.rarity)
    ?? (source.provenance === 'official' || source.isSeeded ? 'legendary' : undefined)
    ?? (source.provenance === 'editors-pick' ? 'epic' : undefined)
    ?? (source.provenance === 'community-shared' || source.publicWorkspaceId ? 'rare' : undefined)
  if (!rarity) return {}
  return {
    rarity,
    accent: displayCardRarityAccent(rarity),
    state: source.exploreOrigin?.featured ? 'featured' : undefined,
  }
}
